import client from "../client";

export interface RPSGameBetResponse {
  ID?: number;
  Amount?: number;
  CreateAt?: Date;
  UpdateAt?: Date;
}

export default function API(): Promise<RPSGameBetResponse[]> {
  return client
    .get(`gameinhouse/rps/rps_game_bet`)
    .then((response) => response.data);
}
